import Button from '@/common/components/Button';
import { CopyButton } from '@/common/components/CopyButton';
import { useCopyButton } from '@/common/hooks/useCopyButton';
import IncreaseTefTableVersion from '@/features/establishments/components/GeneralData/IncreaseTefTableVersion';
import { format } from 'date-fns';
import ResumeBox from '../ResumeBox';

interface tefIdentifierProps {
  identifier?: string
  matrixBranchLatestTefDatasetCreatedAt?: string | null
  matrixBranchLatestTefDatasetVersion?: string | null
  matrixBranchId?: string
  establishmentCompanyId?: string
  establishmentCompanyIsRefetching?: boolean
  establishmentCompanyIsPending?: boolean
}

export const TefIdentifierSection = ({
  identifier,
  matrixBranchLatestTefDatasetCreatedAt,
  matrixBranchLatestTefDatasetVersion,
  matrixBranchId,
  establishmentCompanyId,
  establishmentCompanyIsRefetching,
  establishmentCompanyIsPending,
}: tefIdentifierProps) => {
  const { control, copySuccess } = useCopyButton()

  if (!identifier && !establishmentCompanyIsPending) return null

  return (
    <div className="flex space-x-2 bg-white-200 rounded-lg p-4">
      <ResumeBox
        boxClassName='p-0 bg-transparent flex-1'
        labelClassName='text-[11px] leading-3'
        loadingMode="valueAndLabel"
        label="Código do TEF"
        value={(
          <div className="flex items-center gap-2">
            <p className="text-sm">
              {identifier}
            </p>

            <Button variant="link-white" disabled={!identifier} onClick={() => identifier && copySuccess(identifier)}>
              <CopyButton control={control} className="size-4" />
            </Button>
          </div>
        )}
        isLoading={establishmentCompanyIsPending}
      />

      <div className='border-l border-white-300 min-h-full' />

      <ResumeBox
        boxClassName='p-0 bg-transparent flex-1'
        labelClassName='text-[11px] leading-3'
        loadingMode={establishmentCompanyIsPending ? 'valueAndLabel' : 'valueOnly'}
        label="Versão da tabela"
        value={(
          <div className="flex items-center gap-2">
            <p className="text-sm" data-testid="tef_table_version_code">
              {matrixBranchLatestTefDatasetVersion ?? '--'}
            </p>
          </div>
        )}
        isLoading={establishmentCompanyIsPending || establishmentCompanyIsRefetching}
      />

      <div className='border-l border-white-300 min-h-full' />

      <ResumeBox
        boxClassName='p-0 bg-transparent flex-1'
        labelClassName='text-[11px] leading-3'
        loadingMode={establishmentCompanyIsPending ? 'valueAndLabel' : 'valueOnly'}
        label="Última carga"
        value={(
          <div className="flex items-center gap-2">
            <p className="text-sm" data-testid="tef_table_last_charge_date">
              {matrixBranchLatestTefDatasetCreatedAt
                ? format(matrixBranchLatestTefDatasetCreatedAt, 'dd/MM/yyyy')
                : '--'}
            </p>
          </div>
        )}
        isLoading={establishmentCompanyIsPending || establishmentCompanyIsRefetching}
      />

      {matrixBranchId && establishmentCompanyId && (
        <IncreaseTefTableVersion matrixBranchId={matrixBranchId} establishmentCompanyId={establishmentCompanyId} />
      )}
    </div>
  )
}
